module.exports = __webpack_public_path__ + "media/components/HowItWorks/components/ReadyToFind/lock-ecfdaea7b23c094db2e71c60ef896459.jpg";